import{f as o}from"../../function-bind/index.js";var t=o.call(Function.call,Object.prototype.hasOwnProperty);export{t as s};
//# sourceMappingURL=index.js.map
